interface BillingPlanFreeDescriptionInterface {
  apiCalls: number;
}

export const BillingPlanFreeDescription = ({ apiCalls }: BillingPlanFreeDescriptionInterface) => (
  <>
    You&apos;re currently on Universal API&apos;s free tier, which includes a total of{' '}
    {apiCalls.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} API calls. This gives you full access to explore
    integrations and capabilities at your own pace.
    <br />
    <br />
    Once your limit is reached, you can upgrade at any time to continue building without interruptions.
  </>
);
